import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["form", "startDate", "endDate"]

    submit() {
        this.formTarget.requestSubmit()
    }

    quickFilter(event) {
        const button = event.currentTarget
        const days = parseInt(button.dataset.days)
        const endDate = new Date()
        const startDate = new Date()

        // Instant visual feedback
        const allButtons = button.parentElement.querySelectorAll('button')
        allButtons.forEach(btn => {
            btn.classList.remove('bg-white', 'text-primary', 'shadow-sm')
            btn.classList.add('text-slate-400', 'hover:text-slate-600')
        })
        button.classList.add('bg-white', 'text-primary', 'shadow-sm')
        button.classList.remove('text-slate-400', 'hover:text-slate-600')

        if (days > 0) {
            startDate.setDate(endDate.getDate() - days)
        } else {
            startDate.setFullYear(2020, 0, 1)
        }

        this.startDateTarget.value = this.formatDate(startDate)
        this.endDateTarget.value = this.formatDate(endDate)

        this.submit()
    }

    formatDate(date) {
        let year = date.getFullYear();
        let month = (1 + date.getMonth()).toString().padStart(2, '0');
        let day = date.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    }
}
